export interface StyleProductExposureItem {
  id?: number | string;
  shop_sku?: string;
}

export function createStyleProductExposureGuard() {
  const exposedProductIds = new Set<string>();

  return (item: StyleProductExposureItem): boolean => {
    if (!item.id) {
      return false;
    }

    const productId = String(item.id);

    if (exposedProductIds.has(productId)) {
      return false;
    }

    exposedProductIds.add(productId);
    return true;
  };
}

// 模块生命周期与当前未刷新的页面一致，路由内重挂载时仍保留已曝光商品。
export const shouldTrackStyleProductExposure = createStyleProductExposureGuard();
